import React, { createContext, useContext, useState } from 'react';

export type Page = 'home' | 'nexo' | 'logitrax' | 'axolote' | 'privacy' | 'cookies';

interface RouterContextType {
  page: Page;
  navigate: (p: Page) => void;
}

const RouterContext = createContext<RouterContextType>({ page: 'home', navigate: () => {} });

export const RouterProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [page, setPage] = useState<Page>('home');
  const navigate = (p: Page) => {
    setPage(p);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  return <RouterContext.Provider value={{ page, navigate }}>{children}</RouterContext.Provider>;
};

export const useRouter = () => useContext(RouterContext);
